/* global axios */
import ApiClient from '../ApiClient';

// Teletel assistant (phase 1): bots, FAQs, inbox links and a playground — all
// on Teletel's own endpoints, never Captain's.
class TeletelAssistantAPI extends ApiClient {
  constructor() {
    super('teletel/assistant', { accountScoped: true });
  }

  listBots() {
    return axios.get(`${this.url}/bots`);
  }

  createBot(payload) {
    return axios.post(`${this.url}/bots`, payload);
  }

  updateBot(id, payload) {
    return axios.patch(`${this.url}/bots/${id}`, payload);
  }

  deleteBot(id) {
    return axios.delete(`${this.url}/bots/${id}`);
  }

  listFaqs(botId, status = '') {
    return axios.get(`${this.url}/bots/${botId}/faqs`, { params: { status } });
  }

  createFaq(botId, payload) {
    return axios.post(`${this.url}/bots/${botId}/faqs`, payload);
  }

  updateFaq(botId, id, payload) {
    return axios.patch(`${this.url}/bots/${botId}/faqs/${id}`, payload);
  }

  approveFaq(botId, id) {
    return axios.post(`${this.url}/bots/${botId}/faqs/${id}/approve`);
  }

  deleteFaq(botId, id) {
    return axios.delete(`${this.url}/bots/${botId}/faqs/${id}`);
  }

  listDocuments(botId) {
    return axios.get(`${this.url}/bots/${botId}/documents`);
  }

  addDocument(botId, payload) {
    return axios.post(`${this.url}/bots/${botId}/documents`, payload);
  }

  reingestDocument(botId, id) {
    return axios.post(`${this.url}/bots/${botId}/documents/${id}/reingest`);
  }

  deleteDocument(botId, id) {
    return axios.delete(`${this.url}/bots/${botId}/documents/${id}`);
  }

  approveAllFaqs(botId, documentId = null) {
    return axios.post(`${this.url}/bots/${botId}/faqs/approve-all`, {
      document_id: documentId,
    });
  }

  // Many rows, one request: action is 'approve' or 'delete'.
  bulkFaqs(botId, ids, actionName) {
    return axios.post(`${this.url}/bots/${botId}/faqs/bulk`, {
      ids,
      action_name: actionName,
    });
  }

  // action is 'delete' or 'reingest'.
  bulkDocuments(botId, ids, actionName) {
    return axios.post(`${this.url}/bots/${botId}/documents/bulk`, {
      ids,
      action_name: actionName,
    });
  }

  listScenarios(botId) {
    return axios.get(`${this.url}/bots/${botId}/scenarios`);
  }

  createScenario(botId, payload) {
    return axios.post(`${this.url}/bots/${botId}/scenarios`, payload);
  }

  updateScenario(botId, id, payload) {
    return axios.patch(`${this.url}/bots/${botId}/scenarios/${id}`, payload);
  }

  deleteScenario(botId, id) {
    return axios.delete(`${this.url}/bots/${botId}/scenarios/${id}`);
  }

  listInboxLinks(botId) {
    return axios.get(`${this.url}/bots/${botId}/inbox-links`);
  }

  linkInbox(botId, inboxId) {
    return axios.post(`${this.url}/bots/${botId}/inbox-links`, {
      inbox_id: inboxId,
    });
  }

  unlinkInbox(botId, linkId) {
    return axios.delete(`${this.url}/bots/${botId}/inbox-links/${linkId}`);
  }

  // Who answers in one conversation: the assistant or the agent.
  conversationState(conversationId) {
    return axios.get(`${this.url}/conversations/${conversationId}`);
  }

  resumeAssistant(conversationId) {
    return axios.post(`${this.url}/conversations/${conversationId}/resume`);
  }

  pauseAssistant(conversationId) {
    return axios.post(`${this.url}/conversations/${conversationId}/pause`);
  }

  // What the assistant did lately, and the questions it handed to a human.
  performance(botId) {
    return axios.get(`${this.url}/bots/${botId}/performance`);
  }

  ask(botId, question, history = []) {
    return axios.post(`${this.url}/bots/${botId}/ask`, { question, history });
  }
}

export default new TeletelAssistantAPI();
